module.exports = __webpack_public_path__ + "static/media/icon-duvidas.ccad4e94.svg";